document.addEventListener('DOMContentLoaded', function () {
  const seasonalWrappers = document.querySelectorAll('.seasonal__image-box .image-box-container');
  let flktySeasonal = [];

  function initSeasonalSlider() {
    if (!seasonalWrappers.length) return;

    if (window.innerWidth <= 798) {
      seasonalWrappers.forEach((wrapper, index) => {
        if (!flktySeasonal[index]) {
          flktySeasonal[index] = new Flickity(wrapper, {
            cellAlign: 'left',
            contain: true,
            wrapAround: false,
            prevNextButtons: false,
            pageDots: true,
            draggable: true,
            cellSelector: '.image-with-text__box-column'
          });
        }
      });
    } else {
      flktySeasonal.forEach((instance, index) => {
        if (instance) {
          instance.destroy();
          flktySeasonal[index] = null;
        }
      });
    }
  }

  initSeasonalSlider();
  window.addEventListener('resize', initSeasonalSlider);
});